import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBike = (props) => /* @__PURE__ */ _jsx("svg", {
	height: 30,
	viewBox: "0 0 30 30",
	width: 30,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "m1108.7 276.577a4.552 4.552 0 1 1 -4.553 4.552 4.552 4.552 0 0 1 4.553-4.552zm14.895 0a4.552 4.552 0 1 1 -4.552 4.552 4.552 4.552 0 0 1 4.552-4.552zm-10.8-.689 7.537-.763-4.83 7.608-6.8-1.6zm8.783-2.884-2.121.152 4.136 7.973m-12.832-6.886h2.634",
			stroke: "currentColor",
			strokeLinejoin: "bevel",
			strokeMiterlimit: 10,
			transform: "translate(-1101 -264.504)"
		}), /* @__PURE__ */ _jsx("circle", {
			cx: 15,
			cy: 15,
			r: 15
		})]
	})
});
export default SvgBike;
